<div class="card mb-0">
  <div class="card-header">
    <span class="fa fa-table"></span> &nbsp; Broker
  </div>
  <div class="card-body">
    <div class="row justify-content-start p-0">
      <div class="col-12 col-sm-6">
        <div class="input-group mb-3 zindex-1 form-group">
          <input class="form-control mt-0 mb-0" type="text" style="padding:8px;margin:15px auto;width:30%;"
            placeholder="Search..." (keyup)="updateFilter($event)" />

          <button class="btn btn-outline-secondary" type="button" id="button-addon2">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>
    <!--Table Rows-->

    <div class="technical-datatable responsive-datatable">
      <ngx-datatable #pbTable class="material" [headerHeight]="tableOptions.HeaderHeight" [scrollbarH]="true"
        [footerHeight]="tableOptions.FooterHeight" [columnMode]="tableOptions.ColumnMode"
        [rowHeight]="tableOptions.RowHeight" [rowClass]="getRowClass" [rows]="rows" id="objectTable"
        [perfectScrollbar]="config" [limit]="10" [selectAllRowsOnPage]="true" (activate)="onRowActivate($event)">
        <ngx-datatable-column name="Action" [headerCheckboxable]="true" [width]="70" [sortable]="false"
          [canAutoResize]="false" [draggable]="false" [resizeable]="false" class="cell-center">
          <ng-template ngx-datatable-cell-template let-row="row">
            <input type="checkbox" (change)="checkboxRowSelect(row)" (click)="$event.stopPropagation()" [(ngModel)]="row.isSelected">
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Broker Name" [sortable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span>
              {{row.BrokerName}}
            </span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Broker Number" [sortable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span>
              {{row.BrokerNumber}}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Broker Pseudonym" [sortable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span>
              {{row.BrokerPseudonym}}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
          <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
            let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">

            <div>
              <div><strong> {{rowCount}} total</strong></div>
            </div>

            <div>
              <app-datatable-pager [page]="curPage" [visiblePagesCount]="currentVisible" [size]="pageSize"
                [count]="rowCount" [hidden]="false" (change)="pbTable.onFooterPage($event)">
              </app-datatable-pager>
            </div>
            <div style="color: #212529;">
              <div></div>
            </div>
          </ng-template>
        </ngx-datatable-footer>

      </ngx-datatable>

    </div>
  </div>

  <div class="card-footer">
    <div class="text-end">
      <button type="button" (click)="select()" class="btn btn-primary">Select</button>
      <button type="button" class="btn btn-dark ms-2" (click)="close()">Close</button>
    </div>
  </div>
</div>